import isElectron from 'is-electron';

import appConfig from 'app-config';

const API_URL = 'https://metric.telavox.se';

const status = (response) => {
    if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response);
    } else {
        return Promise.reject(new Error(response.statusText));
    }
};

const sendMetric = (pathList) => {
    if (!appConfig.production) {
        return;
    }

    if (!Array.isArray(pathList)) {
        return;
    }

    const path = `flow.${desktopOrWeb}.${pathList.join('.')}`;

    const body = [
        {
            path: path,
        },
    ];
    fetch(API_URL + '/metrics', {
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(status)
        .then((/*data*/) => {
            //success
        })
        .catch((error) =>
            console.error('failed to send client metric: ', error),
        );
};

const desktopOrWeb = isElectron() ? 'desktop' : 'web';

const client = {
    sendCallEndedMetric: (pathList) => {
        sendMetric(['call_ended', ...pathList]);
    },
    __sendMetric: (pathList) => sendMetric(pathList),
};

export default client;
